/**
 * @file edit-technical-field.tsx
 * @module app/modals/edit-technical-field
 * @description Renders the edit technical field modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CrossSvg from "../../_admin/assets/media/close.png";
import { CustomSelect } from "../custom/Select/CustomSelect";
import { CreatableSelectTable } from "../custom/Select/CreatableSelectTable";
import {
  DateSelection,
  MultiLineText,
  MultiSelection,
  SingleLineText,
  SingleSelection,
} from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import APICallService from "../../api/apiCallService";
import { master } from "../../api/apiEndPoints";
import { success } from "../../Global/toast";
import { masterToast } from "../../utils/toast";
import clsx from "clsx";
import { getKey } from "../../Global/history";
import { warehouse as warehouseStoreString } from "../../utils/storeString";
import { useWarehouse } from "../context/WarehouseContext";
const EditTechnicalField = (props: any) => {
  const { selectedWarehouse } = useWarehouse();
  const navigate = useNavigate();
  const [technical, setTechnical] = useState<any>(props.editData);
  const [initialTechnical, setInitialTechnical] = useState<any>(props.editData);
  console.log("vvvvvvvvvvvvv", technical, initialTechnical);
  const [validations, setValidations] = useState<any>({
    name: false,
    options: false,
    type: props.editData.type,
  });
  const selectOptions = [
    {
      title: "SingleLineTextbox",
      value: SingleLineText,
      name: "SingleLineTextbox",
      label: (
        <>
          <span className="fs-16 fw-600">Single line textbox</span>
        </>
      ),
    },
    {
      value: SingleSelection,
      name: " SingleSelection",
      title: " SingleSelection",
      label: (
        <>
          <span className="fs-16 fw-600">Single selection</span>
        </>
      ),
    },
    {
      value: MultiLineText,
      name: "MultiLineTextbox",
      title: "MultiLineTextbox",
      label: (
        <>
          <span className="fs-16 fw-600">Multi line textbox</span>
        </>
      ),
    },
    {
      value: MultiSelection,
      name: "MultiSelection",
      title: "MultiSelection",
      label: (
        <>
          <span className="fs-16 fw-600">Multi selection</span>
        </>
      ),
    },
    {
      value: DateSelection,
      name: "DateSelection",
      title: "DateSelection",
      label: (
        <>
          <span className="fs-16 fw-600">Date selection</span>
        </>
      ),
    },
  ];
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(props.editData.options);
  const handleChange = (event: any) => {
    let temp = { ...technical };
    temp.type = event.value;
    setTechnical(temp);
  };
  const createOption = (label: string) => ({
    label,
    value: label,
    title: label,
  });
  const handleNameChange = (event: any) => {
    let temp = { ...technical };
    let validationTemp = { ...validations };
    validationTemp.name = false;
    if (event.target.value.trimStart().length === 0) {
      validationTemp.name = true;
    }
    setValidations(validationTemp);
    temp.name = event.target.value.trimStart();
    setTechnical(temp);
  };
  const handleMultiSelect = (inputValue: string) => {
    let temp = { ...technical };
    const newOption = createOption(inputValue);
    setOptions((prev: any) => [...prev, newOption]);
    let optionTemp = [...options, newOption];
    temp.options = optionTemp;
    setTechnical(temp);
  };
  const handleInputChange = (inputValue: string) => {
    let temp = { ...technical };
    temp.inputValue = inputValue;
    setTechnical(temp);
  };
  const handleKeyDown = (event: any) => {
    switch (event.key) {
      case "Enter":
      case "Tab":
        if (event.target.value.trimStart().length > 0) {
          let temp = { ...technical };
          const newOption = createOption(event.target.value.trimStart());
          temp.options = [...temp.options, newOption];
          let validationTemp = { ...validations };
          if (temp.options.length > 0) {
            validationTemp.options = false;
          } else {
            validationTemp.options = true;
          }
          setValidations(validationTemp);
          temp.inputValue = "";
          setTechnical(temp);
        }
        event.preventDefault();
    }
  };
  const handleMultiSelectChange = (inputValue: any) => {
    let temp = { ...technical };
    let validationTemp = { ...validations };
    if (inputValue.length > 0) {
      validationTemp.options = false;
    } else {
      validationTemp.options = true;
    }
    setValidations(validationTemp);
    temp.options = inputValue;
    setTechnical(temp);
  };
  const handleSave = async () => {
    let temp = { ...technical };
    let validationTemp = { ...validations };
    let valid: any = [];
    if (
      temp.type === SingleLineText ||
      temp.type === MultiLineText ||
      temp.type === DateSelection
    ) {
      if (temp.name === "") {
        validationTemp.name = true;
        valid.push(true);
      }
    } else {
      if (temp.name === "") {
        validationTemp.name = true;
        valid.push(true);
      }
      if (temp.options.length === 0) {
        validationTemp.options = true;
        valid.push(true);
      }
    }
    let allTrue = valid.some((el: any) => {
      return el === true;
    });
    if (!allTrue) {
      setLoading(true);
      let apiService = new APICallService(
        master.editTechnicalDetails,
        technical,
        { id: technical._id },
        "",
        "",
        "",
        props.moduleName,
        selectedWarehouse?.value || null
      );
      let response = await apiService.callAPI();
      if (response) {
        success(masterToast.editTechnical);
        navigate(props.redirectPath ?? "/master-old/technical-details");
        props.handleClose(technical, true);
      }
      setLoading(false);
    }
  };
  return (
    <>
      <Modal
        {...props}
        show={props.show}
        onHide={props.handleClose}
        dialogClassName="modal-dialog-centered min-w-lg-590px"
        className="border-r10px"
      >
        <Modal.Header className="border-bottom-0 pb-6 text-center mx-auto">
          <img
            className="close-inner-top-2"
            width={40}
            height={40}
            src={CrossSvg}
            alt="closebutton"
            onClick={props.handleClose}
          />
          <Modal.Title className="fs-26 fw-bolder mw-lg-375px mt-5">
            Edit technical field details for Food category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0 custom-form-light">
          <Form.Group className="mb-6" controlId="formBasicEmail">
            <Form.Label>Field name</Form.Label>
            <Form.Control
              className={clsx(
                "form-control-solid form-control-custom bg-light",
                validations.name ? "border-danger" : ""
              )}
              type="email"
              placeholder="Type here..."
              value={technical.name}
              onChange={(event: any) => {
                handleNameChange(event);
              }}
              disabled={loading}
            />
            {validations.name ? (
              <Form.Label className="text-danger">
                Please enter field name
              </Form.Label>
            ) : (
              <></>
            )}
          </Form.Group>
          <Form.Group className="mb-6" controlId="formBasicEmail">
            <Form.Label>Input type</Form.Label>
            <CustomSelect
              backgroundColor={"#f9f9f9"}
              onChange={(event: any) => {
                handleChange(event);
              }}
              default={selectOptions.find(
                (val: any) => val.value === technical.type
              )}
              options={selectOptions}
              isMulti={false}
              disabled={loading}
            />
          </Form.Group>
          {technical.type === DateSelection ? (
            <div className="bg-white p-3">
              <span className="fs-15 fw-600">
                The seller can add date for this field.
              </span>
            </div>
          ) : (
            <></>
          )}
          {technical.type === MultiSelection ||
          technical.type === SingleSelection ? (
            <>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Add options for selections</Form.Label>
                <CreatableSelectTable
                  getOptionLabel={(option: any) => {
                    return <>{option.title}</>;
                  }}
                  border={
                    validations.options ? "#e55451 !important" : "#e0e0df"
                  }
                  inputValue={technical.inputValue}
                  placeholder="Type here..."
                  // defaultValue={generalData.variant.Flavour.selectors}
                  options={options}
                  isMulti={true}
                  onCreateOption={(event: any) => {
                    handleMultiSelect(event);
                  }}
                  onChange={(newValue: any) =>
                    handleMultiSelectChange(newValue)
                  }
                  onInputChange={(newValue: any) => handleInputChange(newValue)}
                  display="none"
                  value={
                    technical.options &&
                    technical.options.map(
                      (optionVal: any, optionIndex: number) => {
                        return optionVal;
                      }
                    )
                  }
                  menuIsOpen={false}
                  onKeyDown={(event: any, newValue: any) =>
                    handleKeyDown(event)
                  }
                  isDisabled={loading}
                />
                {validations.options ? (
                  <Form.Label className="text-danger">
                    Please add options for selections
                  </Form.Label>
                ) : (
                  <></>
                )}
              </Form.Group>
            </>
          ) : (
            <></>
          )}{" "}
        </Modal.Body>
        <Modal.Footer className="justify-content-center pt-1 mb-4 border-top-0">
          <Button className="uw-btn uw-btn-primary uw-btn-lg" variant="primary" size="lg" onClick={handleSave}>
            {!loading && (
              <span className="indicator-label fs-16 fw-bold">
                Save Changes
              </span>
            )}
            {loading && (
              <span
                className="indicator-progress fs-16 fw-bold"
                style={{ display: "block" }}
              >
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditTechnicalField;
